export const STRINGS = {
  FR: {
    FORM_ERROR_FIELD_REQUIRED: 'Ce champs est obligatoire',
    FORM_ERROR_FIELD_PASSWORD_NOT_EQUAL:
      'Les mots de passe ne sont pas identiques',
    FORM_ERROR_FIELD_PASSWORD_NOT_STRONG_ENOUGH:
      "Le mot de passe n'est pas assez sécurisé",
    FORM_ERROR_FIELD_NIR_INCORRECT:
      "Ce numéro de sécurité sociale n'est pas valide",
    FORM_ERROR_FIELD_EMAIL_INCORRECT: "Cette adresse e-mail n'est pas valide",
    FORM_ERROR_PASSWORD_MIN_LENGTH:
      'Ce champs doit comporter au moins 6 charactères',
    FORM_ERROR_AT_LEAST_ONE: 'Au moins un de ces champs doit être renseigné',
    FORM_ERROR_MAX_ONE: 'Un seul de ces champs doit être renseigné',
    FORM_ERROR_INVALID_CHARACTER:
      'Ce champ contient un ou plusieurs caractère(s) invalide(s)',
    PRESCRIPTION_ERROR_DOCTOR_NAME_MISSING: 'le nom du médecin',
    PRESCRIPTION_ERROR_RPPS_AM_OR_FINESS_MISSING:
      'le numéro d’activité du médecin (N° RPPS, AM ou FINESS)',
    PRESCRIPTION_ERROR_INVALID_IMAGE: 'Image floue ou illisible',
    PRESCRIPTION_ERROR_PDF_HAS_MULTIPLE_PAGES:
      'Le PDF contient plusieurs pages',
    SET_PATIENT_AGREEMENT:
      'J’accepte que mes données soient envoyées et utilisées uniquement au laboratoire à des fins médicales.',
    SET_PATIENT_ERROR_AGREEMENT:
      'Veuillez accepter l’envoi de vos données au laboratoire afin de poursuivre le processus de prise de rendez-vous et de pré-enregistrement de votre dossier.',
    INFORMATION_NOTICE_TITLE:
      'Notice d’information relatives aux données personnelles',
    INFORMATION_NOTICE_QUESTION_1:
      'Finalités des traitements des données personnelles ?',
    INFORMATION_NOTICE_TEXT_QUESTION_1:
      'La solution Le Pass a pour finalité de faciliter votre prise en charge médicale au laboratoire en vous permettant de :',
    INFORMATION_NOTICE_LIST_ITEM_1: 'sélectionner un horaire de rendez-vous',
    INFORMATION_NOTICE_LIST_ITEM_2:
      'pré enregistrer votre dossier administratif',
    INFORMATION_NOTICE_TEXT_2_QUESTION_1:
      ' Ainsi, les traitements de ces données à caractère personnel sont indispensables à votre prise en charge au sein de votre laboratoire. Ils s’effectuent sous le régime de l’obligation légale (RGPD – Art. 6.1.c pour les données administratives), en vue de la réalisation de votre diagnostic médical (RGPD – Art. 9.2.h pour les données de santé).',
    INFORMATION_NOTICE_QUESTION_2:
      'Quels sont vos droits et comment les exercer ?',
    INFORMATION_NOTICE_TEXT_QUESTION_2:
      'Conformément au règlement général sur la protection des données et à la loi informatique et libertés, vous disposez de droits afin de garder la maitrise de vos données à caractère personnel : ',
    INFORMATION_NOTICE_LIST_QUESTION_2_ITEM_1: 'Le droit à l’information',
    INFORMATION_NOTICE_LIST_QUESTION_2_ITEM_2:
      'Le droit de vérification et de rectification',
    INFORMATION_NOTICE_LIST_QUESTION_2_ITEM_3:
      'Le droit à l’effacement (« droit à l’oubli »)',
    INFORMATION_NOTICE_LIST_QUESTION_2_ITEM_4:
      'Le droit à la limitation du traitement',
    INFORMATION_NOTICE_LIST_QUESTION_2_ITEM_5: 'Le droit d’opposition',
    INFORMATION_NOTICE_MAIL:
      'Pour toute question relative à la protection de vos données ou pour exercer vos droits, vous pouvez vous adresser directement à',
    INFORMATION_NOTICE_CNIL:
      'En cas de difficultés, vous pouvez également saisir la Commission Nationale Informatique et Liberté (CNIL) d’une réclamation.'
  }
};
